/**
 * SmtpAlanlari — E-posta Hesapları ekle / düzenle penceresinin "nereden ve nasıl gönderilir" bölümü (backlog #573, backend #566).
 * İki pencere de aynı bölümü kullanır: sunucu, port, bağlantı güvenliği (SSL | STARTTLS), SMTP kullanıcı adı, gönderen adı ve "sistemin varsayılan göndericisi".
 *
 *   deger     : hesap nesnesi (smtp_host, smtp_port, smtp_security, smtp_username, smtp_from_name, is_default)
 *   degistir  : (kısmi nesne) => void
 *   varsayilanGizle / ipucuGizle : kişisel hesap sayfası (#574) "sistemin varsayılan göndericisi" kutusunu ve Amazon SES ipucunu göstermez
 *   kullaniciSecili : hesap bir kullanıcıya atanmış → varsayılan gönderici OLAMAZ (backend de reddeder), kutu kapalı gösterilir
 *
 * Şifre alanı bu bileşende değil, iki pencerenin kendi yerinde kalır (yalnız yazılır, hiçbir okuma geri vermez).
 */
import React from 'react';
import { Col, FormText, Input, Label, Row } from 'reactstrap';
import { useTranslation } from 'react-i18next';

const PORT_ONERISI = { SSL: 465, STARTTLS: 587 };

const SmtpAlanlari = ({ deger, degistir, kullaniciSecili, varsayilanGizle = false, ipucuGizle = false }) => {
    const { t } = useTranslation('moduller');
    const d = deger || {};

    function guvenlikSec(v) {
        const patch = { smtp_security: v };
        const portBos = d.smtp_port === '' || d.smtp_port === null || d.smtp_port === undefined;
        if (portBos && PORT_ONERISI[v]) patch.smtp_port = PORT_ONERISI[v];
        degistir(patch);
    }

    return (
        <div className="border rounded p-3 mb-3">
            <h6 className="mb-3">{t('emailsConfigs.smtpBaslik')}</h6>
            <Row>
                <Col md={8}>
                    <Label className="form-label" htmlFor="smtp-host">{t('emailsConfigs.smtpSunucu')}</Label>
                    <Input
                        id="smtp-host" className="mb-3" type="text" autoComplete="off" placeholder="email-smtp.eu-west-1.amazonaws.com"
                        value={d.smtp_host || ''} onChange={(e) => degistir({ smtp_host: e.target.value })}
                    />
                </Col>
                <Col md={4}>
                    <Label className="form-label" htmlFor="smtp-port">{t('emailsConfigs.smtpPort')}</Label>
                    <Input
                        id="smtp-port" className="mb-3" type="number" min={1} max={65535} placeholder="587"
                        value={d.smtp_port ?? ''} onChange={(e) => degistir({ smtp_port: e.target.value === '' ? '' : Number(e.target.value) })}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <Label className="form-label" htmlFor="smtp-guvenlik">{t('emailsConfigs.smtpGuvenlik')}</Label>
                    <Input id="smtp-guvenlik" className="mb-3" type="select" value={d.smtp_security || ''} onChange={(e) => guvenlikSec(e.target.value)}>
                        <option value="">{t('emailsConfigs.guvenlikSecin')}</option>
                        <option value="SSL">{t('emailsConfigs.guvenlikSsl')}</option>
                        <option value="STARTTLS">{t('emailsConfigs.guvenlikStarttls')}</option>
                    </Input>
                </Col>
                <Col md={6}>
                    <Label className="form-label" htmlFor="smtp-kullanici">{t('emailsConfigs.smtpKullanici')}</Label>
                    <Input
                        id="smtp-kullanici" className="mb-3" type="text" autoComplete="off"
                        value={d.smtp_username || ''} onChange={(e) => degistir({ smtp_username: e.target.value })}
                    />
                </Col>
            </Row>
            <Label className="form-label" htmlFor="smtp-gonderen">{t('emailsConfigs.gonderenAdi')}</Label>
            <Input
                id="smtp-gonderen" className="mb-1" type="text" placeholder="FDS"
                value={d.smtp_from_name || ''} onChange={(e) => degistir({ smtp_from_name: e.target.value })}
            />
            {!ipucuGizle && <FormText className="d-block mb-3">{t('emailsConfigs.smtpIpucu')}</FormText>}
            {!varsayilanGizle && (
                <>
                    <div className="form-check">
                        <Input
                            id="smtp-varsayilan" className="form-check-input" type="checkbox" disabled={Boolean(kullaniciSecili)}
                            checked={Boolean(d.is_default) && !kullaniciSecili} onChange={(e) => degistir({ is_default: e.target.checked })}
                        />
                        <Label className="form-check-label" htmlFor="smtp-varsayilan">{t('emailsConfigs.varsayilanGonderici')}</Label>
                    </div>
                    <FormText className="d-block">{kullaniciSecili ? t('emailsConfigs.varsayilanAtanmisOlmaz') : t('emailsConfigs.varsayilanAciklama')}</FormText>
                </>
            )}
        </div>
    );
};

export default SmtpAlanlari;
